import { Button, Modal } from 'antd';
import React from 'react';

import type { TicketCategoryTableData } from '../../types';
import { DETAIL_FIELD_NAMES } from './constants';
import styles from './index.module.scss';

type DetailModalProps = {
  showModal: boolean;
  closeModal: () => void;
  ticketCategoryData: TicketCategoryTableData | undefined;
};

export const DetailModal = ({
  showModal,
  closeModal,
  ticketCategoryData,
}: DetailModalProps) => {
  return (
    <Modal
      open={showModal}
      onCancel={closeModal}
      destroyOnClose
      centered
      title={<h4 className={styles['mb-0']}>查看票券類別</h4>}
      footer={[
        <Button key="close" onClick={closeModal}>
          關閉
        </Button>,
      ]}
    >
      {ticketCategoryData ? (
        <ul>
          {Object.entries(ticketCategoryData).map(([key, value]) => {
            const isValidField = !!DETAIL_FIELD_NAMES[key];
            return isValidField ? (
              <li className={styles.info} key={key}>
                <h5 className={styles.infoTitle}>{DETAIL_FIELD_NAMES[key]}</h5>
                {key === 'imageUrl' && value ? (
                  <img
                    className={styles.infoImage}
                    src={value}
                    alt="票券類別圖片"
                  />
                ) : (
                  <p className={styles.infoContent}>{value}</p>
                )}
              </li>
            ) : null;
          })}
        </ul>
      ) : (
        <div className={styles.noData}>
          <h3 className={styles['mb-0']}>無資料內容</h3>
        </div>
      )}
    </Modal>
  );
};
